module.exports = __webpack_public_path__ + "bf394d7045d9354e2f15c7f97f7e4880.svg";